import { useLocalStorage } from '@/hooks'

import { DEFAULT_LINK_COLOR, parseLinkColor } from './linked-columns.constants'

export const LINK_COLOR_STORAGE_KEY = 'linked-columns-link-color'

// Note: one stored value for every page that uses LinkedColumns, like the link style
export const useLinkColor = (): [string, (color: string) => void] => {
  const [stored, setStored] = useLocalStorage<string>(LINK_COLOR_STORAGE_KEY, DEFAULT_LINK_COLOR)

  return [parseLinkColor(stored), setStored]
}
